import Toggle from './toggle.element.js';

export default Toggle;

Toggle.define('wje-toggle', Toggle);
